import { ref, watch } from 'vue'
import { useTheme } from 'vuetify'

const STORAGE_KEY = 'qlerify-theme'
const RESOLVED_KEY = 'qlerify-theme-resolved'

const themePreference = ref(localStorage.getItem(STORAGE_KEY) || 'light')
const resolvedTheme = ref(localStorage.getItem(RESOLVED_KEY) || 'light')
let initialized = false

export const isDarkTheme = () => resolvedTheme.value === 'dark'

function getSystemTheme () {
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
}

function resolveTheme (preference) {
  if (preference === 'system') {
    return getSystemTheme()
  }
  return preference
}

const useAppTheme = () => {
  const vuetifyTheme = useTheme()

  const applyTheme = (resolved) => {
    document.documentElement.classList.add('theme-switching')
    document.documentElement.setAttribute('data-theme', resolved)
    vuetifyTheme.global.name.value = resolved
    localStorage.setItem(RESOLVED_KEY, resolved)
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        document.documentElement.classList.remove('theme-switching')
      })
    })
  }

  const setTheme = (preference) => {
    themePreference.value = preference
    localStorage.setItem(STORAGE_KEY, preference)
    resolvedTheme.value = resolveTheme(preference)
    applyTheme(resolvedTheme.value)
  }

  const toggleTheme = () => {
    setTheme(themePreference.value === 'dark' ? 'light' : 'dark')
  }

  if (!initialized) {
    initialized = true

    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
    const handleSystemChange = () => {
      if (themePreference.value === 'system') {
        resolvedTheme.value = getSystemTheme()
        applyTheme(resolvedTheme.value)
      }
    }
    mediaQuery.addEventListener('change', handleSystemChange)

    watch(themePreference, () => {
      resolvedTheme.value = resolveTheme(themePreference.value)
      applyTheme(resolvedTheme.value)
    }, { immediate: true })
  }

  return {
    themePreference,
    resolvedTheme,
    setTheme,
    toggleTheme
  }
}

export default useAppTheme
